import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WavingHandIcon(props: IconProps) {
    return <Icon {...props} iconKey={"waving_hand"}/>
}
